module.exports = __webpack_public_path__ + "static/Insurance-7bc6e2db9b80430a4d3059112fef4db8.png";